import {useEffect, useState} from "react";
import FeatureAppAPI from '~/api/featureAppApi';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAnglesRight} from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";

function FeatureAppSession(){
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        FeatureAppAPI.getAll()
            .then((res) => {
                setFeatures(res.data.Results);
                setLoading(false);
            })
            .catch((err) => {
                ;
            });
    }, []);
    return (
        <section className="pt-15 pb-0" id="feature">
            <div className="container-medium">
                <div className="position-relative z-2">
                    <div className="row">
                        <div className="col-lg-6 text-center text-lg-start pe-xxl-3">
                            <h4 className="text-primary fw-bolder mb-4">Features</h4>
                            <h2 className="mb-3 text-body-emphasis lh-base fs-6">Seamless Payments: A Fully <br
                                className="d-md-none"/>Integrated Suite</h2>
                            <p className="mb-5 fs-9">With the power of Phoenix, you can now focus only on functionaries
                                for
                                your digital products, while leaving the UI design on us!With the power of Phoenix, you
                                can now focus only on functionaries for your digital products, while leaving the UI
                                design on us!</p><a className="btn btn-lg btn-outline-primary rounded-pill me-2"
                                                    href="/ai-chatbot">Find out more
                            <FontAwesomeIcon icon={faAnglesRight} className="ms-2"/>
                        </a>
                        </div>
                        <div className="col-sm-6 col-lg-3 mt-7 text-center text-lg-start">
                            <div className="h-100 d-flex flex-column justify-content-between">
                                <div className="border-start-lg border-translucent border-dashed ps-4"><img
                                    className="mb-4"
                                    src="https://prium.github.io/phoenix/v1.23.0/assets/img/icons/illustrations/bolt.png"
                                    width="48"
                                    height="48" alt=""/>
                                    <div>
                                        <h5 className="fw-bolder mb-2">Lightning Speed</h5>
                                        <p className="fw-semibold lh-sm fs-9">Present everything you need in one place
                                            within
                                            minutes! Grow with Phoenix!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3 mt-7 text-center text-lg-start">
                            <div className="h-100 d-flex flex-column">
                                <div className="border-start-lg border-translucent border-dashed ps-4"><img
                                    className="mb-4"
                                    src="https://prium.github.io/phoenix/v1.23.0/assets/img/icons/illustrations/pie.png"
                                    width="48"
                                    height="48" alt=""/>
                                    <div>
                                        <h5 className="fw-bolder mb-2">All-in-one solution</h5>
                                        <p className="fw-semibold lh-sm fs-9">Show your production and growth graph in
                                            one
                                            place with Phoenix!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        loading && (
                            <div className="mt-4">
                                <Skeleton height={10} count={5} containerClassName={"w-100"}/>
                            </div>
                        )
                    }
                    {
                        !loading &&
                        features.map((item, index) => {
                            return (
                                <div key={item.FeatureAppId} className="row mt-12 align-items-center justify-content-between text-center text-lg-start mb-6 mb-lg-0">
                                    <div className= { (index % 2 ==0) ? 'col-lg-5' : 'col-lg-5 order-0 order-lg-1'}>
                                        <img className="feature-image img-fluid mb-9 mb-lg-0 rounded-3" src={item.ThumbnailUrl} alt="img"/>
                                    </div>
                                    <div className="col-lg-6">
                                        <h3 className="fw-bolder mb-3 lh-sm">{item.Title}</h3>
                                        <p className="mb-4 px-md-7 px-lg-0 fs-8">{item.Description}</p>
                                        <ul className="list-unstyled">
                                            {
                                                item.FeatureAppDescriptions.map((item, index) => {
                                                    return (
                                                        <li className='pb-1 fs-8-1 fw-semibold' key={index}><i className="bi bi-check"></i> {item.Description}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    );
}

export default FeatureAppSession;